/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateUserWeeklyScheduleDto } from '../../models/create-user-weekly-schedule-dto';
import { ResponseUserWeeklyScheduleDto } from '../../models/response-user-weekly-schedule-dto';

export interface UserWeeklyScheduleControllerCreate$Params {
      body: CreateUserWeeklyScheduleDto
}

export function userWeeklyScheduleControllerCreate(http: HttpClient, rootUrl: string, params: UserWeeklyScheduleControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseUserWeeklyScheduleDto>> {
  const rb = new RequestBuilder(rootUrl, userWeeklyScheduleControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseUserWeeklyScheduleDto>;
    })
  );
}

userWeeklyScheduleControllerCreate.PATH = '/thalea-google-events/user-weekly-schedule';
